
// SVG Icon: map-data-active
export default { id: "terriajs-map-data-active" };
export const id = "terriajs-map-data-active";
export const name = "map-data-active";
